import React from 'react';
import { Alert } from 'antd';

type ErrorAlertProps = {
  isVisible: boolean;
  errorLabel: string;
};

const defaultDescription = 'Something went wrong. Please try again later...';

const ErrorAlert: React.FC<ErrorAlertProps> = ({ isVisible, errorLabel }) => {
  const errorDescription = errorLabel
    ? `An error has occurred when trying to get ${errorLabel}! Please try again later!`
    : defaultDescription;

  if (!isVisible) {
    return null;
  }

  return <Alert message="Error" description={errorDescription} type="error" showIcon />;
};

export default ErrorAlert;
